var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row no-gutters mb-3" }, [
      _c("div", { staticClass: "col-12 mb-3" }, [
        _c("div", { staticClass: "mr-md-4 pb-3 rounded shadow-sm" }, [
          _c(
            "div",
            { staticClass: "col-head py-2 px-3 rounded-top text-white" },
            [_vm._v("Training Videos")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-3 my-2", attrs: { id: "user_section" } },
            [
              _vm._l(_vm.appConfig.trainingDoc, function(tData, tKey) {
                return [
                  _c(
                    "div",
                    { key: tKey, staticClass: "col-12 d-inline-block mt-2" },
                    [
                      _vm.checkFileExt("video", tData.ext)
                        ? [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "d-inline-block smaller-font-content qrp-text-link",
                                attrs: {
                                  href: "JavaScript:void(0);",
                                  id: tKey
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.showTrainingVideo(
                                      tData.path,
                                      tData.name
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(tData.name))]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkFileExt("doc", tData.ext)
                        ? [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "d-inline-block smaller-font-content qrp-text-link",
                                attrs: {
                                  href: tData.path,
                                  target: "_blank",
                                  id: tKey
                                }
                              },
                              [_vm._v(_vm._s(tData.name))]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 mb-4" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78e2d95e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e2d95e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/TrainingVideo.vue
// module id = null
// module chunks = 